<style>
body {  font-size: 16px;}
.container {
  box-sizing: content-box;
  margin: 30px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}
.download-section {
  background: #f0f8ff;
  border: 2px dashed #3c5998;
  border-radius: 8px;
  padding: 15px;
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  text-align: center;
}
.profile-section {
  display: flex;
  align-items: center;
  gap: 25px;
}
.profile-section img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 3px solid #3c5998;
  object-fit: cover;
}
.section {
  margin-top: 35px;
}
.section h3 {
  border-bottom: 2px solid #3c5998;
  padding-bottom: 5px;
  margin-bottom: 15px;
  color: #3c5998;
}
.info-table {
  width: 100%;
  border-collapse: collapse;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.6); /* dark glass */
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-box {
  text-align: center;
  color: #fff;
  animation: fadeIn 0.5s ease;
}

.ring {
  width: 60px;
  height: 60px;
  border: 5px solid transparent;
  border-top: 5px solid #3c5998;
  border-right: 5px solid #6366f1;
  border-radius: 50%;
  animation: spin 1s linear infinite, glow 1.5s ease-in-out infinite;
  margin: 0 auto 15px;
}

/* Smooth spinning */
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

/* Glow pulse effect */
@keyframes glow {
  0%, 100% {
    box-shadow: 0 0 10px #3c5998;
  }
  50% {
    box-shadow: 0 0 25px #6366f1;
  }
}

/* Fade animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
<template>
  <v-container class="min-h-screen px-4">
    <div class="logo position-relative">
      <a href="/" class="d-block text-decoration-none position-relative">
        <img
          src="@/assets/images/logos/LOGO-1.png"
          alt="logo-icon"
          class="logo-icon"
          max-width="60"
          width="45"
          height="auto"
        />
        <span class="logo-text fw-bold text-dark">MERO PRINTS</span>
      </a>
    </div>
    
    <div v-if="loading" class="loader-overlay">
      <div class="loader-box">
        <div class="ring"></div>
        <p>Loading your data...</p>
      </div>
    </div>
    <div v-else class="container" >
      <div v-if="(Array.isArray(student) && student.length > 0) || (!Array.isArray(student) && student)">
        <div class="download-section" onclick="window.open('https://merovidya.com/app-redirect/meroprints/', '_blank')">
          <h3>📱 Download our Mobile App</h3>
          <p>Click here to download our mobile app.</p>
        </div>
        <div class="profile-section">
          <img :src="student.image || '../src/assets/images/logos/LOGO-1.png'"
            alt="Profile Image" />
          <div>
            <h2>{{ student.name }}</h2>
            <p>Code No: {{ student.unique_code }}</p>
          </div>
        </div>
        <div class="section">
          <h3>Contact Information</h3>
          <table class="info-table table">
            <tbody>            
              <tr>
                <td style="width: 35%;">Contact Number</td>
                <td>
                  <span>{{student.contact}}</span>
                </td>
              </tr>
              <tr>
                <td>Address</td>
                <td>
                  <span>{{student.address}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="section">
          <h3>Guardian Information</h3>
          <table class="info-table table">
            <tbody>
              <tr>
                <td style="width: 35%;">Parent Name</td>
                <td>
                  <span>{{ student.parent_name }}</span>
                </td>
              </tr>
              
            </tbody>
          </table>
        </div>
        <!-- <div class="section">
        <h3>Emergency Details</h3>
        <table class="info-table table">
          <tbody>
            <tr>
              <td>Emergency Contact</td>
              <td>
                <span >Dipak Basnet (9844444444) - Brother</span>
              </td>
            </tr>
            <tr>
              <td>Blood Group</td>
              <td>
                <span ></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->
        <div class="section">
          <h3>Academic Information</h3>
          <table class="info-table table">
            <tbody>
              <tr>
                <td style="width: 35%;">School/College</td>
                <td>
                  <span>{{ student.school }}</span>
                </td>
              </tr>
              <tr>
                <td>Class</td>
                <td>
                  <span>{{ student.class_name }}</span>
                </td>
              </tr>
              <tr>
                <td>Year</td>
                <td>
                  <span>{{ student.year }}</span>
                </td>
              </tr>
              <!-- <tr>
                <td>Section</td>
                <td>
                  <span>A</span>
                </td>
              </tr> -->
              <tr>
                <td>Roll No.</td>
                <td>
                  <span>{{ student.roll_no }}</span>
                </td>
              </tr>            
            </tbody>
          </table>
        </div>
        <div class="alert alert-info mt-3">
          <i>If the record shown above is incorrect, please contact your school/college administration to update the record.</i>
        </div>
      </div>
      <div v-else class="text-center d-flex align-center justify-center " style="height: 65vh;">
        <h1>Page Not Found</h1>>
      </div>
    </div>
  </v-container>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { fetchStudent } from "@/services/apiServices";

export default defineComponent({
  name: "StudentProfile",
  setup() {
    const route = useRoute();
    const student = ref(null);
    const loading = ref(true)
    
    watch(
      () => route.params.id,
      async (newId) => {
        if (newId) {
          try {
            const response = await fetchStudent(newId);
            student.value = response.data;
            // console.log("response", response);
          } catch (error) {
            console.error(error);
          } finally {
            loading.value = false;
          }
        }
      },
      { immediate: true }
    );
    return{
      student,
      loading
    }

  },
});
</script>